export default __webpack_public_path__ + "static/media/cust_own_id_display.bd581a7e.png";